import React, { useState } from 'react'
import PurchaseCard from '../../components/purchseCards/PurchaseCard';
import Licenses from '../../assets/data/licenses'
import { Box, Typography } from '@mui/material';

function PurchaseCards() {

  const individualLicense = Licenses.individual;
  const teamLicense = Licenses.team;
  const enterpriseLicense = Licenses.enterprise;

  return (
    <>
      <Typography variant='h4' sx={{ fontSize: '1.8rem', textAlign: 'center', mt: 7 }} >Choose a License Type</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', m: 2 }} >
        <PurchaseCard title="Individual License" price="$ 4500" license={individualLicense} />
        <PurchaseCard title="Team License" price="$ 5950" license={teamLicense} />
        <PurchaseCard title="Enterprise License" price="$ 7950" license={enterpriseLicense} />
      </Box>
    </>
  )
}

export default PurchaseCards
